import globalVariables from "./globalVariables";
import urls from "./urls";

export async function get(url, headers = {}) {
    // await getFreshToken();
    if (Object.keys(headers).length === 0) {
        headers = {
            'Authorization': `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`,
            'Content-Type': 'application/json'
        }
    }
    try {
        const response = await fetch(url, {
            headers: headers,
            method: 'GET',
        });
        const data = await response.json();
        return data;
    } catch (error) {
        // handle error
        console.log(error);
        return false;
    }
}

export async function post(url, post_data = {}, headers = {}) {
    // if (useFreshToken) {
    //     await getFreshToken();
    // }
    if (Object.keys(headers).length === 0) {
        headers = {
            'Authorization': `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`,
            'Content-Type': 'application/json'
        }
    }
    try {
        const response = await fetch(url, {
            headers: headers,
            method: 'POST',
            body: post_data,
        });
        const data = await response.json();
        return data;
    } catch (error) {
        // handle error
        console.log(error);
        return false;
    }
}

export async function put(url, post_data = {}, headers = {}) {
    // await getFreshToken();
    if (Object.keys(headers).length === 0) {
        headers = {
            'Authorization': `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`,
            'Content-Type': 'application/json'
        }
    }
    try {
        const response = await fetch(url, {
            headers: headers,
            method: 'PUT',
            body: post_data,
        });
        const data = await response.json();
        return data;
    } catch (error) {
        // handle error
        console.log(error);
        return false;
    }
}

export async function patch(url, post_data = {}, headers = {}) {
    // await getFreshToken();
    if (Object.keys(headers).length === 0) {
        headers = {
            'Authorization': `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`,
            'Content-Type': 'application/json'
        }
    }
    try {
        const response = await fetch(url, {
            headers: headers,
            method: 'PATCH',
            body: post_data,
        });
        const data = await response.json();
        return data;
    } catch (error) {
        // handle error
        console.log(error);
        return false;
    }
}

export async function del(url, headers = {}) {
    // await getFreshToken();
    if (Object.keys(headers).length === 0) {
        headers = {
            'Authorization': `Bearer ${localStorage.getItem(globalVariables.AUTH_TOKEN)}`,
            'Content-Type': 'application/json',
        };
    }
    try {
        const response = await fetch(url, {
            headers: headers,
            method: 'DELETE',
        });
        if (response.ok) {
            return true; // Successfully deleted
        } else {
            const errorData = await response.json();
            console.log('Delete Error:', errorData);
            return false;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
}

// export async function getFreshToken() {
//     let refresh_token = localStorage.getItem(globalVariables.REFRESH_TOKEN)
//     if (refresh_token === null) {
//         return false
//     }
//     let headers = {
//         "Authorization": `Bearer ${refresh_token}`,
//         'content-type': 'application/json'
//     }
//     try {
//         const response = await fetch(urls.TOKEN_REFRESH, {
//             headers: headers,
//             method: 'POST',
//             body: {},
//         });
//         const data = await response.json();
//         if (data['success']) {
//             localStorage.setItem(globalVariables.AUTH_TOKEN, data['access_token'])
//             return true
//         }
//         else {
//             localStorage.clear()
//             window.location.replace('/')
//             return false
//         }
//         // return data
//     } catch (error) {
//         // handle error
//         console.log(error);
//         return false
//     }
// }

export async function getFreshToken() {
    let isAlertShown = false;
    let refresh_token = localStorage.getItem(globalVariables.REFRESH_TOKEN);
    // let password = localStorage.getItem(globalVariables.USER_PASSWORD);
    // let user_name = localStorage.getItem(globalVariables.USER_NAME);

    let body_data = {
        // password,
        // "username": user_name,
        "refresh" : refresh_token
    };

    body_data = JSON.stringify(body_data);

    // console.log("-----body_data----getFreshToken()", body_data);
    // console.log("-----refresh_token----getFreshToken()", refresh_token);
    
    if (!refresh_token) {
        return false
    }
    let headers = {
        // "Authorization": `Bearer ${refresh_token}`,
        'content-type': 'application/json'
    }
    try {
        const response = await fetch(urls.TOKEN_REFRESH, {
            headers: headers,
            method: 'POST',
            body: body_data,
        });
        const data = await response.json();
        // console.log("----getFreshToken---res--->>", response);
        // console.log("----getFreshToken---data--->>", data);
        if (response.statusText === 'OK') {
            localStorage.setItem(globalVariables.AUTH_TOKEN, data.data[0].access)
            return true
        }
        else {
             if (!isAlertShown) {
                isAlertShown = true;
                localStorage.clear();
                alert("Your session has expired. Please sign in again.");
                // window.location.replace('/');
            }
            return false;
        }
        
    } catch (error) {
        // handle error
        console.log(error);
        return false
    }

    //     try {
//         const response = await fetch(urls.TOKEN_REFRESH, {
//             headers: headers,
//             method: 'POST',
//             body: body_data,
//         });
//         const data = await response.json();
//         if (data['success']) {
//             localStorage.setItem(globalVariables.AUTH_TOKEN, data['access_token'])
//             return true
//         }
//         else {
//             localStorage.clear()
//             window.location.replace('/')
//             return false
//         }
//         // return data
//     } catch (error) {
//         // handle error
//         console.log(error);
//         return false
//     }
}